import { EnvSchema } from '../entities/envSchema';

const slt: EnvSchema = {
  env: 'slt',
  envName: '数智财务',
};

export default slt;
